import { BFFAgent } from 'BFFAgent';
import {
  UPDATE_VERSION_PIVOT_BEGIN,
  UPDATE_VERSION_PIVOT_SUCCESS,
  UPDATE_VERSION_PIVOT_FAILURE,
} from './constants';

export function updateVersionPivot(row) {
  return async(dispatch) => { 
    dispatch({
      type: UPDATE_VERSION_PIVOT_BEGIN,
    });

    try{
      const result = await BFFAgent.Datamasters.updateVersionPivot(row)
      dispatch({
          type: UPDATE_VERSION_PIVOT_SUCCESS,
          data: result,
      });
    }catch(error){
      dispatch({
          type: UPDATE_VERSION_PIVOT_FAILURE,
          data: error,
      });
    }
  }
  }


export function reducer(state, action) {
  switch (action.type) {
    case UPDATE_VERSION_PIVOT_BEGIN:
      return {
        ...state,
        updateVersionPivotPending: true,
        updateVersionPivotError: null,
        updateVersionPivotSuccess: false,
      };

    case UPDATE_VERSION_PIVOT_SUCCESS:
      return {
        ...state,
        updateVersionPivotPending: false,
        updateVersionPivotError: null,
        updateVersionPivotSuccess: true,
      };

    case UPDATE_VERSION_PIVOT_FAILURE:
      return {
        ...state,
        updateVersionPivotPending: false,
        updateVersionPivotError: action.data,
        updateVersionPivotSuccess: false,
      };
    default:
      return state;
  }
}
